import React, { useState, useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import { PulseLoader } from "react-spinners"; // Importing the loader

import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { CasesColumns } from "../../../data/DynamicTable/Collumns";
import { caseManagementUrl, HRService } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { allRelievers } from "../../../data/Columns/hrmanagement";

const base_url = HRService.uri;

function RelieversByApplicationId(props) {
  const data = JSON.parse(localStorage.getItem("MyLeaveApplicationsData"));
 
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const actions = {
    entity: "Cases",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },

    add: {
      key: "ADD",
      button_name: "File New Case",
      Show_Button: false,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
      inputObjectName: "acivateDeactivateCase",
    },
    ViewCase: {
      key: "VIEWDETAILS",
      button_name: "View Details",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    updateCaseStatus: {
      key: "UPDATECASESTATUS",
      button_name: "Update Case Status",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    modelName: "Cases",
    showStatus: false,
    dataObject: {
      inputFields: {
        leaveApplicationId: data.id,
      },
      inputObjectName: "relieversByApplicationId",
      inputSubObjectName: "reliever",
      returnFields: [
        "id",
        "relieverId",
        "applicantId",
        "applicationId",
        "companyId",
        "isActive",
        "status",
        "statusDescription",
        "genderId",
        "branchId",
        "regionId",
        "leaveType",
        "applicantFirstName",
        "applicantLastName",
        "relieverFirstName",
        "relieverLastName",
        "role",
        "roleGroup",
        "branch",
        "region",
      ],
    },
  };
  const title = `Relievers`;

  const subtitle = `View All Relievers  `;

  return (
    <Box m="2px" p="1rem">
    

      <DynamicTable
        title={title}
        subtitle={subtitle}
        columns={allRelievers}
        // FormComponent={CasesForm}
        //query={allCasesView}
        base_url={base_url}
        actions={actions}
      />
      {/* //)} */}
    </Box>
  );
}

export default RelieversByApplicationId;
